<template>
  <div>
    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardBody>
            <CRow>
              <CCol lg="3">
                <div>
                  <label for="filterUserGroup">User Group</label>
                  <model-select
                    class="form-control"
                    id="filterAgen"
                    :options="userGroupList"
                    v-model="filter.user_group"
                    placeholder="-- ALL --"
                  ></model-select>
                </div>
              </CCol>

              <CCol lg="3">
                <div >
                  <label for="filterStatus">Status</label>
                  <model-select
                    class="form-control"
                    id="filterStatus"
                    :options="statusList"
                    v-model="filter.status"
                    placeholder="-- ALL --"
                  ></model-select>
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol lg="12">
                <br />
                <CButton size="sm" @click="searching" color="info">
                  <i class="fa fa-search"></i>
                  Filter
                </CButton>
                &nbsp;
                <CButton size="sm" @click="clearFilter" color="danger">
                  <i class="fa fa-undo"></i>
                  Clear
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>

      <!-- <CCol lg="12">
        <GlobalTable
          :title="title + ' List'"
          :fields="fields"
          :items="items"
          :editButton="true"
          :redirectDetail="true"
          :isLoading="isLoading"
          @addForm="addForm"
        ></GlobalTable>
      </CCol> -->
    </CRow>

    <CRow>
      <CCol lg="12">
        <CCard>
          <CCardHeader>
            <slot name="header">
              <CIcon name="cil-grid" />
              {{ title }}
            </slot>
          </CCardHeader>

          <CCardBody>
            <template v-if="!isLoading">
              <TableButton
                :listBoxSource="listBoxSource"
                :visibilityShow="visibilityShow"
                :title="title"
                :enableExportAllUser="true"
                @addForm="addForm"
                @showHide="showHide"
                @exportXls="exportXls"
                @myListBoxOnCheckChange="myListBoxOnCheckChange($event)"
              ></TableButton>

              <CRow>
                <CCol sm="12">
                  <JqxGrid
                    v-if="items"
                    ref="myGrid"
                    :width="'100%'"
                    :source="items"
                    :columns="fields"
                    :columnsresize="true"
                    :sortable="true"
                    :pageable="true"
                    :autoheight="true"
                    :showfilterrow="true"
                    :filterable="true"
                    :enablebrowserselection="false"
                    :enablehover="true"
                    :editable="false"
                    :altrows="true"
                    :localization="localization"
                    :selectionmode="'multiplerowsadvanced'"
                  >
                  </JqxGrid>
                </CCol>
              </CRow>
            </template>
           <Loading v-else></Loading>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addButton"
    >
      <template #header>
        <h6 class="modal-title">Add Form {{ title }}</h6>
      </template>

      <CForm>
        <CRow>
          <CCol sm="3">
            <CInput
              label="Nama User"
              invalid-feedback="Name should be filled"
              required
              v-model="$v.usersForm.name.$model"
              :is-valid="!$v.usersForm.name.$invalid"
            />
          </CCol>

          <CCol sm="3">
            <CInput
              type="email"
              label="Email"
              invalid-feedback="Email should be filled"
              required
              v-model="$v.usersForm.email.$model"
              :is-valid="!$v.usersForm.email.$invalid"
              was-validated
            />
          </CCol>

          <CCol sm="3">
            <CInput
              label="Handphone"
              invalid-feedback="Mobilephone should be filled"
              required
              v-model="$v.usersForm.mobile_phone.$model"
              :is-valid="!$v.usersForm.mobile_phone.$invalid"
            />
          </CCol>

          <CCol sm="3">
            <CInput
              type="password"
              label="Password"
              invalid-feedback="Password should be filled"
              required
              v-model="$v.usersForm.password.$model"
              :is-valid="!$v.usersForm.password.$invalid"
              was-validated
            />
          </CCol>
        </CRow>

        <CRow>
          <CCol sm="3">
            <CTextarea
              label="Alamat Utama"
              invalid-feedback="Address should be filled"
              required
              v-model="$v.usersForm.address.$model"
              :is-valid="!$v.usersForm.address.$invalid"
              rows="5"
            />
          </CCol>

          <CCol sm="3">
            <CTextarea
              label="Alamat Utama 2"
              invalid-feedback="Address 2 should be filled"
              required
              v-model="$v.usersForm.address_2.$model"
              :is-valid="!$v.usersForm.address_2.$invalid"
              rows="5"
            />
          </CCol>

          <CCol sm="3">
            <CTextarea
              label="Alamat Utama 3"
              invalid-feedback="Address 3 should be filled"
              required
              v-model="$v.usersForm.address_3.$model"
              :is-valid="!$v.usersForm.address_3.$invalid"
              rows="5"
            />
          </CCol>
        </CRow>
      </CForm>

      <template #footer>
        <CButton @click="cancelForm" color="danger">
          <i class="fa fa-undo"></i>
          Cancel
        </CButton>
        <CButton
          @click="submitForm"
          :disabled="$v.usersForm.$invalid"
          color="success"
        >
          <i class="fa fa-save"></i>
          Accept
        </CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
// import GlobalTable from "../../../templates/Table";
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import Loading from "@/templates/Loading.vue";
import TableButton from "@/templates/TableButton";
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";
import JqxInput from "jqwidgets-scripts/jqwidgets-vue/vue_jqxinput.vue";

export default {
  name: "User",
  components: { JqxInput, Loading, TableButton, JqxGrid },
  data() {
    return {
      title: "User",
      source: {
        localdata: [],
        datafields: [
          { name: "id", type: "number" },
          { name: "user_code", type: "string" },
          { name: "name", type: "string" },
          { name: "email", type: "string" },
          { name: "mobile_phone", type: "string" },
          { name: "user_group_name", type: "string" },
          { name: "date_inserted", type: "date" },
          { name: "status_name", type: "string" },
        ],
        datatype: "json",
      },
      editrow: -1,

      fields: [
        {
          datafield: "user_code",
          columntype: "textbox",
          filtertype: "textbox",
          text: "User Code",
          createfilterwidget: function (column, columnElement, widget) {
            widget.jqxInput({ width: '100%', height: 27, placeHolder: "Cari User Code" });
          }
        },
        {
          datafield: "name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Nama User",
          createfilterwidget: function (column, columnElement, widget) {
            widget.jqxInput({ width: '100%', height: 27, placeHolder: "Cari Nama User" });
          }
        },
        {
          datafield: "email",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Email",
          createfilterwidget: function (column, columnElement, widget) {
            widget.jqxInput({ width: '100%', height: 27, placeHolder: "Cari Email" });
          }
        },
        {
          datafield: "mobile_phone",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Handphone",
          createfilterwidget: function (column, columnElement, widget) {
            widget.jqxInput({ width: '100%', height: 27, placeHolder: "Cari Handphone" });
          }
        },
        {
          datafield: "user_group_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "User Group",
          createfilterwidget: function (column, columnElement, widget) {
            widget.jqxInput({ width: '100%', height: 27, placeHolder: "Cari User Group" });
          }
        },
        {
          datafield: "date_inserted",
          columntype: "datetimeinput",
          filtertype: "range",
          text: "Tanggal Registrasi",
          cellsformat: "d",
          cellsalign: "right",
          hidden:true,
        },
        {
          datafield: "status_name",
          columntype: "textbox",
          filtertype: "textbox",
          text: "Status",
          createfilterwidget: function (column, columnElement, widget) {
            widget.jqxInput({ width: '100%', height: 27, placeHolder: "Cari Status" });
          }
        },
        {
          text: "Action",
          align: "center",
          name: "EditAction",
          columntype: "button",
          width: 60,
          sortable: false,
          filtertype: "none",
          menu: false,
          cellsrenderer: () => {
            return "Edit";
          },
          buttonclick: (row) => {
            let dataRecord = this.$refs.myGrid.getrowdata(row);
            let path = this.$route.path.split("/");

            this.$router.push({
              path: path.hasOwnProperty("2")
                ? path[2] + "/detail/" + dataRecord.id
                : "detail/" + dataRecord.id,
            });
          },
        }
      ],

      listBoxSource: [
        {
          label: "Name User",
          value: "name",
          checked: true,
        },
        {
          label: "Email",
          value: "email",
          checked: true,
        },
        {
          label: "Handphone",
          value: "mobile_phone",
          checked: true,
        },
        {
          label: "User Group",
          value: "user_group_name",
          checked: true,
        },
        {
          label: "Tanggal Registrasi",
          value: "date_inserted",
          checked: false,
        },
        {
          label: "Status",
          value: "status_name",
          checked: true,
        },
      ],
      
      usersForm: tableInterfaces.users,
      items: null,
      isLoading: false,
      isEdit: false,
      addButton: false,
      filter: {
        user_group: null,
        status: null,
      },
      userGroupList: [],
      statusList: [],
      localization: getLocalization("en"),
      visibilityShow: false,
    };
  },
  validations: {
    usersForm: {
      user_code: {},
      password: { required },
      name: { required },
      email: { required },
      mobile_phone: { required },
      address: { required },
      address_2: {},
      address_3: {},
      status: {},
      uuid: {},
      date_inserted: {},
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    //NewTable Function --start
    exportXls: function () {
      this.$refs.myGrid.exportdata("xls", "users");
    },
    exportPdf: function () {
      this.$refs.myGrid.exportdata("pdf", "users");
    },
    myListBoxOnCheckChange: function (event) {
      this.$refs.myGrid.beginupdate();
      if (event.args.checked) {
        this.$refs.myGrid.showcolumn(event.args.value);
      } else {
        this.$refs.myGrid.hidecolumn(event.args.value);
      }
      this.$refs.myGrid.endupdate();
    },
    showHide: function () {
      this.visibilityShow = !this.visibilityShow;
    },
    // NewTable Function --end
    init: function () {
      this.isEdit = false;
      this.cancelForm();
      this.getUserDropdown();
      this.getUserListing();
    },
    searching: function () {
      this.getUserListing(this.filter);
    },
    clearFilter: function () {
      this.filter = {
        agent: null,
        status: null
      };
      this.getUserListing(this.filter);
    },
    getUserListing: function (filter = {}) {
      this.isLoading = true;
      this.axios
        .post("console/users/listing", filter)
        .then((response) => {
          if (response.data.status === 2000) {
            //this.items = response.data.data;
            const temp = this.source;
            temp.localdata = response.data.data;
            this.items = new jqx.dataAdapter(temp);
            
            this.showInfoNotification({
              title: this.title,
              message: response.data.message,
            });
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getUserDropdown: function () {
      this.isLoading = true;
      this.axios
        .get("console/dropdown/users")
        .then((response) => {
          if (response.data.status === 2000) {
            this.userGroupList = response.data.user_group;
            this.statusList = response.data.user_status;
          } else {
            this.showErrorNotification({
              title: this.title,
              message: response.data.message,
            });
          }
        })
        .catch((error) => {
          this.showErrorNotification({
            title: this.title,
            message: error,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addForm: function () {
      this.addButton = true;
      this.resetForm();
    },
    cancelForm: function () {
      this.addButton = false;
      this.resetForm();
    },
    editForm: function (item) {
      this.addForm();
      this.isEdit = true;
      this.usersForm = item;
    },
    resetForm: function () {
      for (var i in tableInterfaces.users) {
        tableInterfaces.users[i] = null;
      }
      this.usersForm = tableInterfaces.users;
    },
    submitForm: function (event) {
      event.preventDefault();
      if (confirm("Do you want to add new user ?")) {
        let path = this.$route.path.split("/");
        this.isLoading = true;
        this.axios
          .post("console/users/add", this.usersForm)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: this.title,
                message: response.data.message,
              });
              this.$router.push({
                path: path[2] + "/detail/" + response.data.id,
              });
            } else {
              this.showErrorNotification({
                title: this.title,
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.showErrorNotification({
              title: this.title,
              message: error,
            });
          })
          .finally(() => {
            this.isLoading = false;
            this.init();
          });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
